import { type AddressDto } from './Address';
import { type EnumType } from './EnumType';

export type AcceptInvitationRequestDto = {
  invitation_id: string;
  password: string;
  confirm_password: string;
  name?: string;
  email?: string;
  phone?: string;
  document_number?: string;
  person_type?: EnumType;
  crc?: string;
  code?: string;
  address?: AddressDto;
};

export const initialAcceptInvitationRequestDtoEmpty: AcceptInvitationRequestDto = {
  invitation_id: '',
  password: '',
  confirm_password: '',
  name: '',
  email: '',
  phone: '',
  document_number: '',
  person_type: { value: 'PHYSICAL', description: 'Pessoa física' },
  crc: '',
  code: '',
  address: {
    street: '',
    neighborhood: '',
    complement: '',
    city: '',
    number: '',
    zip_code: '',
  },
};
